jQuery.noConflict();
(function ($) {
  $(document).ready(function () {
    var skillset = document.querySelector("#skillset");

    if (skillset === null) {
        //console.log('element does NOT exist in DOM');
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting === true) {
            //console.log('Element is fully visible in screen');
            function skillSet() {
              // Iterate over each element w/ a class of
              // bar-info, storing the value of data-total
              // in a variable.  Using jQuery's CSS method,
              // dynamically update the width of each bar.
              $(".bar-info").each(function () {
                total = $(this).data("total");
                $(this).css("width", total + "%");
              });

              // Iterate over each element w/ the class percent.  Using
              // jQuery's $(this) will allow us to interact w/ each specific
              // object in the loop.  Then use jQuery's super awesome animate method
              // to implement a counter on each .percent element, which will "count"
              // up incrementally until it reaches the number inside the percent span,
              // aka it's "ceiling".
              $(".percent").each(function () {
                var $this = $(this);
                $({
                  Counter: 1,
                }).animate(
                  {
                    Counter: $this.text(),
                  },
                  {
                    duration: 3000,
                    easing: "swing",
                    step: function () {
                      $this.text(Math.ceil(this.Counter) + "%");
                    },
                  }
                );
              });
            }
            // Invoke our skillSet function inside a setTimeout,
            // to create a short delay before the animation begins.
            setTimeout(skillSet, 0);
            observer.unobserve(entries[0].target);
          }
        },
        { threshold: [1] }
      );

      observer.observe(skillset);
    };
  });
})(jQuery);
